class TabController extends AbstractIntegrationController
	@register()
	@inject '$uibModal',
		'translate'
		'configuration'
		'configurationOptions'
		'IntegrationRepository'
		'ToastService'

	integrationId: 'tab'

	initialize: ->
		@additionalButtonsTemplate = '@app/integration/tab/tab.additional-buttons.view.html'

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}

	showOrderSyncModal: ->
		@$uibModal
			.open
				size: 'sm'
				templateUrl: '@app/integration/tab/modals/tab.order.modal.view.html'
				bindToController: true
				controllerAs: 'orderSelectModal'
				controller: ($uibModalInstance) ->
					$onInit: ->
						@modal = $uibModalInstance
			.result
			.then (orderId) =>
				@IntegrationRepository.run(@integrationId, null, "resend/#{orderId}")
